import React from "react";
import PropTypes from "prop-types";
// utils
import { handleAnalyticsClick } from "../utils/analytics";

const FlipCard = ({ image, title, techStack, projectLink }) => {
  return (
    <div className="flip-card">
      <div className="flip-card-inner">
        <div className="flip-card-front d-flex flex-column justify-content-center align-items-center">
          <img src={image} alt={title} className="img-fluid rounded" />
          <p className="text-light lead project-title">{title}</p>
        </div>
        <div className="flip-card-back d-flex flex-column justify-content-center align-items-center p-3">
          <h4>Tech Stack</h4>
          <ul className="list-unstyled text-start">
            {techStack.map((tech) => (
              <li key={tech.name || tech.id}>
                <i className={`me-2 blue ${tech.icon}`}></i>
                {tech.name}
              </li>
            ))}
          </ul>
          <a
            href={projectLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn custom-btn mt-2"
            onClick={handleAnalyticsClick("Project", `${title}`)}
          >
            Check Website Here
          </a>
        </div>
      </div>
    </div>
  );
};

FlipCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  techStack: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      id: PropTypes.string,
    })
  ).isRequired,
  projectLink: PropTypes.string.isRequired,
};

export default FlipCard;
